export default __webpack_public_path__ + "static/media/20240209_203348.28b96b98.jpg";